import React from "react";
import "./SherlocPlatformBudgetSummary.css";

const UNAVAILABLE_LABEL = "Unavailable";
const CLIENT_UNAVAILABLE_LABEL = "Allocation unavailable";

const SummaryFinancial = ({ label, value, dataAttribute }) => {
  const displayValue = String(value || "").trim() || UNAVAILABLE_LABEL;

  return (
    <span
      className="smp-platform-budget-summary-financial"
      aria-label={`${label} budget: ${displayValue}`}
      {...{ [dataAttribute]: "true" }}
    >
      <span className="smp-platform-budget-summary-financial-label">{label}</span>
      <span className="smp-platform-budget-summary-financial-value">{displayValue}</span>
    </span>
  );
};

export default function SherlocPlatformBudgetSummary({
  rows = [],
  financialMode = "gross-net",
}) {
  const summaryRows = Array.isArray(rows) ? rows.filter(Boolean) : [];
  if (!summaryRows.length) return null;

  const isClientSafe = financialMode === "client";

  return (
    <section
      className="smp-platform-budget-summary"
      aria-label="Platform budget summary"
      data-sherloc-allocation-summary={financialMode}
    >
      <ul className="smp-platform-budget-summary-list">
        {summaryRows.map((row, index) => {
          const key = String(row.key || row.label || `platform-${index}`);
          const label = String(row.label || "Platform");
          const percentLabel = String(row.percentLabel || "").trim();
          const grossAmountLabel = String(row.grossAmountLabel || "").trim();
          const netAmountLabel = String(row.netAmountLabel || "").trim();

          return (
            <li
              key={key}
              className="smp-platform-budget-summary-row"
              data-sherloc-allocation-summary-row={key}
            >
              <span className="smp-platform-budget-summary-identity">
                {row.image ? (
                  <img
                    className="smp-platform-budget-summary-icon"
                    src={row.image}
                    alt=""
                    aria-hidden="true"
                    loading="lazy"
                    decoding="async"
                    width="34"
                    height="34"
                  />
                ) : null}
                <span className="smp-platform-budget-summary-name">{label}</span>
                {percentLabel ? (
                  <span
                    className="smp-platform-budget-summary-percent"
                    aria-label={`Allocation percentage: ${percentLabel}`}
                  >
                    {percentLabel}
                  </span>
                ) : null}
              </span>

              <span className="smp-platform-budget-summary-financials">
                {isClientSafe ? (
                  <span
                    className="smp-platform-budget-summary-financial"
                    aria-label={
                      grossAmountLabel
                        ? `Allocated budget: ${grossAmountLabel}`
                        : CLIENT_UNAVAILABLE_LABEL
                    }
                    data-sherloc-summary-allocated="true"
                  >
                    <span className="smp-platform-budget-summary-financial-label">
                      Allocated budget
                    </span>
                    <span className="smp-platform-budget-summary-financial-value">
                      {grossAmountLabel || CLIENT_UNAVAILABLE_LABEL}
                    </span>
                  </span>
                ) : (
                  <>
                    <SummaryFinancial
                      label="Gross"
                      value={grossAmountLabel}
                      dataAttribute="data-sherloc-summary-gross"
                    />
                    <SummaryFinancial
                      label="Net"
                      value={netAmountLabel}
                      dataAttribute="data-sherloc-summary-net"
                    />
                  </>
                )}
              </span>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
